import { useState } from 'react';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Done from 'images/icons/done.svg';
import noReleases from 'images/deployment-frequency-0.svg';
import ChartBox from 'components/ChartBox';
import BarChart from 'components/highcharts/BarChart';
import RetrospectTrendPopper from './RetrospectTrendPopper';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import AppRouter from 'common/AppRouter';
import _ from 'lodash';
import useRBACPermissions from '../../../hooks/useRBACPermissions';
import { LBButton } from '@linearb/buzz';

const StyledSVG = styled.img`
  width: 100%;
  height: 6rem;
  padding-right: 9rem;
  padding-top: -5rem;
`;

const RetrospectDeploymentFrequency = ({
  releases,
  data = {},
  trendData = {},
  noReleasesInIterations,
  history,
  styleAexs,
  chartColor
}) => {
  const avgReleases =
    data &&
    Object.keys(data).length &&
    (_.sum(Object.values(data).flat()) / Object.keys(data).length).toFixed(1);

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.DASHBOARD,
      click_type: TRACKING.CLICK.DEPLOY_FREQ_TREND
    });
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const tooltipLabels = ['Releases'];
  const totalLine = {
    icon: Done,
    of: 'Releases',
    sum: releases,
    extraInfo: `${avgReleases} avg releases per day`
  };
  const totalLineNoReleases = {
    icon: Done,
    of: 'Releases',
    sum: 'N/A'
  };
  const trendGraphTexts = {
    title: 'DEPLOYMENT FREQUENCY TREND',
    avg: 'avg releases per sprint',
    tooltip: tooltipLabels
  };

  const { isPermitted } = useRBACPermissions();

  return noReleasesInIterations ? (
    <ChartBox
      isOpen={!!anchorEl}
      title='Deployment Frequency'
      totalLine={totalLineNoReleases}
    >
      <Flex direction='row-reverse'>
        <StyledSVG src={noReleases} alt='' />
      </Flex>
      {isPermitted && (
        <>
          <Text pt='2rem' size='large' weight='400'>
            Can't see your releases?
          </Text>

          <LBButton
            variant='ghost'
            onClick={() =>
              history.push({
                pathname: AppRouter.CONFIGURATION.path,
                search: '?isOrgSettings=true'
              })
            }
          >
            Change the way your releases are detected &gt;
          </LBButton>
        </>
      )}
    </ChartBox>
  ) : (
    <ChartBox
      isOpen={!!anchorEl}
      title='DEPLOYMENT FREQUENCY'
      onIconClick={handleClick}
      totalLine={totalLine}
    >
      <BarChart
        tooltipLabels={tooltipLabels}
        data={data}
        barColor={chartColor}
        yProps={styleAexs}
        xProps={styleAexs}
      />
      <RetrospectTrendPopper
        texts={trendGraphTexts}
        icon={Done}
        data={trendData}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      />
    </ChartBox>
  );
};

export default RetrospectDeploymentFrequency;
